import { render } from "./PagoExterno.vue?vue&type=template&id=0fc27ace&scoped=true"
import script from "./PagoExterno.vue?vue&type=script&lang=js"
export * from "./PagoExterno.vue?vue&type=script&lang=js"

import "./PagoExterno.vue?vue&type=style&index=0&id=0fc27ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc27ace"]])

export default __exports__